import React from 'react';
import './Button.scss';

const Button = ({ text, icon, theme, onClick, url }) => {
  /**
   * EJECUTA LA ACCIÓN SEGUN LOS PROPS ENVIADOS.
   * RECIBE COMO PARÁMETROS UNA FUNCIÓN, UNA URL O AMBAS
   *
   * @param {function} cb - Función a ejecutar
   * @param {string} url - Página a visitar
   */
  const handleClick = (cb = null, url = null) => {
    if (url) {
      window.open(url);
    }

    if (typeof cb === 'function') {
      cb();
    }
  };

  return (
    <button
      className={`btn hbi-btn ${theme || ""}`}
      onClick={() => handleClick(onClick, url)}
    >
      {text}
      {icon && <i className={icon} />}
    </button>
  );
};

export default Button;